import React, { Fragment, useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { AppBar, Button, Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useLocation, useNavigate } from 'react-router-dom';
import UndoIcon from '@mui/icons-material/Undo';

import { Bill } from './Bill';
import useFetch from '../../hooks/useFetch';
import { urlGetCertificationById } from '../../helpers';
import './style.css'

export const PrintPDFCertification = () => {

    const location = useLocation();
    const componentRef = useRef();
    const { data, loading } = useFetch(`${urlGetCertificationById}${location.search}`, 'GET');

    let formValues = {};
    let client = {};
    if (!loading && data?.length > 0) {
        const work = data[0].work
        formValues = {
            ...data[0], 'addressWork': work.addressWork, 'characteristics': work.characteristics, 'contact': work.contact, 'iva': work.iva, 'paymentMethod': work.paymentMethod, 'status': work.status, 'date': work.date
        }

        client = [data[0].client];
    }

    const possibleStatus = ['Provisional', 'Aceptado', 'Definitivo'];
    const navigate = useNavigate();

    const handleClick = () => {
        if (possibleStatus.includes(formValues?.status)) {
            navigate('/estimate')
        } else {
            navigate('/certification')
        }
    }

    return (
        <Stack alignItems='center'>
            {!loading && data?.length > 0 ?
                <Fragment>
                    < Bill ref={componentRef} formValues={formValues} client={client} />
                    <AppBar >
                        <div className='appBar'>
                            <Button sx={{ display: 'flex', flexDirection: 'column' }} color='inherit' variant='text' onClick={handleClick}><UndoIcon />Volver</Button>
                            <ReactToPrint
                                trigger={() =>
                                    <Button color='inherit' variant='text'><FileDownloadIcon /><PrintIcon /></Button>
                                }
                                content={() => componentRef.current}
                            />
                        </div>
                    </AppBar>
                </Fragment>
                : <CircularProgress sx={{ marginTop: '5rem' }} />}
        </Stack>
    );
};